import type { AnswersIds } from "@/Modules/Models/Domain/OnBoarding";
import type { UpdateRegistrationUserSSOApiQuery } from "@/Modules/Models/Api/OnBoarding";
import { TherapyType } from "@/Modules/Models/Domain/OnBoarding";

import { updateRegistrationUserSSO } from "@/Services/TherapyApi/OnBoardingFunctional";

import useUserStore from "@/Modules/User/Store";
import useOnboardingStore from "@/Modules/OnBoarding/Store";

import { hasValue } from "@/Utils/Objects";
import { danger } from "@/Utils/Debug";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

async function updateUserRegistrationAH(): Promise<void> {
  const userStore = useUserStore();
  const onBoardingStore = useOnboardingStore();
  const onBoardingData = onBoardingStore.answers;
  const apiQuery = transformDataToApiQuery(onBoardingData);

  onBoardingStore.hasErrorInProcess = false;
  onBoardingStore.errorCode = null;
  onBoardingStore.isLoading = true;

  try {
    if (hasValue(userStore.user)) {
      const uuid = userStore.user.id;

      await updateRegistrationUserSSO(apiQuery, uuid);

      onBoardingStore.isUpdateRegister = true;
    }

    onBoardingStore.setNextStep(null);

    await userStore.setUser();
  } catch (err: unknown) {
    const code = isApiError(err) ? err["error_code"] : null;

    danger(code);

    onBoardingStore.hasErrorInProcess = true;
  } finally {
    onBoardingStore.isLoading = false;
  }
}

function transformDataToApiQuery(
  onBoardingData: Partial<Record<AnswersIds, string>>
): UpdateRegistrationUserSSOApiQuery {
  return {
    username: onBoardingData.username ? onBoardingData.username.toString() : "",
    is_couple: onBoardingData.therapy_type === TherapyType.COUPLE,
    couple_age_detailed: onBoardingData.couple_age,
    couple_gender: onBoardingData.couple_gender,
    patient_subarea: onBoardingData.sub_area ? onBoardingData.sub_area : "",
    tell_me_more: onBoardingData.tell_me_more,
    gender_preference: onBoardingData.therapist_gender_preferences
      ? onBoardingData.therapist_gender_preferences
      : "",
    availability: onBoardingData.therapist_availability ? onBoardingData.therapist_availability : "",
    therapist_name_selected: onBoardingData.therapist_name ? onBoardingData.therapist_name : "",
    privacy_policy_at: parseInt(onBoardingData.privacy_policy_at!),
  };
}

export default updateUserRegistrationAH;
